<template>

<div tabindex="0" class="e-card" id="price">
  <div class="e-card-title" style="display: inline-block">EDIT USER CREDIT</div>
    <div>
      <div class="e-card-content">
      <div class="container2">
        <div class="leftcol">
        <div class="form-row">
          <div style="width:50%; background-color:lightgrey;" class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Applicant Name"
              v-model="userCredit.userFullName"
              :readonly="true"
            />
          </div>
        </div>

        <div class="form-row">
          <div style="width:50%; background-color:lightgrey;" class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Applicant Company"
              v-model="userCredit.companyName"
              :readonly="true"
            />
          </div>
        </div>
        <div class="form-row">
          <div style="width:50%; background-color:lightgrey;" class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Email"
              v-model="userCredit.email"
              :readonly="true"
            />
          </div>
        </div>
        <div class="form-row">
          <div style="width:50%; background-color:lightgrey;" class="form-row-input">
            <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Credit Used:"
              format = 'C2'
              :showSpinButton='numericSpin'
              v-model="userCredit.creditUsed"
              :readonly="true"
             />
          </div>
        </div>
        <div class="form-row">
          <div style="width:50%; background-color:lightgrey;" class="form-row-input">
            <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Credit Remaining:"
              format = 'C2'
             :showSpinButton='numericSpin'
              :readonly="true"
              v-model="userCredit.creditRemaining" />
          </div>
        </div>
        <div class="form-row">
          <div style="width:50%; background-color:lightgrey;" class="form-row-input">
            <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Credit Limit:"
              format = 'C2'
             :showSpinButton='numericSpin'
              v-model="originalCreditTotalAmount"
              :readonly="true"
            />
          </div>
        </div>
        <div class="form-row">
          <div style="width:50%;" class="form-row-input">
            <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Change Credit Limit:"
              format = 'C2'
             :showSpinButton='numericSpin'
              v-model="userCredit.creditTotalAmount" />
          </div>
        </div>
        <div class="form-row">
            <div style="width:20%;" class="form-row-input" v-if="creditUsedIsZero">
                <ejs-button type="button" v-on:click.native="onDeleteCreditClicked"
                            cssClass="e-info margin-button">Delete Credit Limit</ejs-button>
            </div>
            <div style="width:20%;" class="form-row-input">
                <label>Credit Limit: Active/Inactive:</label>
            </div>
            <div style="width:40%;" class="form-row-input">
                <ejs-switch id="status" v-model="userCredit.creditActive"
                :checked="userCredit.creditActive"
                ref="refCreditActive"></ejs-switch>
            </div>
        </div>
        </div>
    </div>
    </div>
    <div class="align-center-bottom">
        <ejs-button type="button" v-on:click.native="onProcessClick"
                      cssClass="e-info margin-button">Save</ejs-button>
        <ejs-button v-on:click.native="onCancelClick"
                      cssClass="e-danger margin-button">Cancel</ejs-button>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { SwitchPlugin } from '@syncfusion/ej2-vue-buttons';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { FETCH_USER_CREDIT_BY_ID, PROCESS_USER_CREDIT } from '../store';
import { deleteUserCredit } from '../services/accounting-api';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogUtility);
let DialogObj;

export default {
  name: 'transactionEdit',
  components: {
  },

  data() {
    return {
      title: 'EDIT User Credit',
      usersData: [],
      userCredit: {
        userId: '',
        userFullName: '',
        companyName: '',
        email: '',
        creditTotalAmount: 0,
        creditUsed: 0,
        creditRemaining: 0,
        description: '',
        creditActive: true,
      },
      originalCreditTotalAmount: 0,
      originalCreditUsed: 0,
      dateMarker: 'Refund Date(yyyy-mm-dd)',
      dateFormat: 'yyyy-MM-dd',
      paymentPaidDate: null,
      numericSpin: false,
    };
  },

  created() {
    // To Getting the USER ID from URL
    if (this.$route.params.id !== '') {
      this.selectedUserId = this.$route.params.id;
    } else {
      this.selectedUserId = '';
    }

    if (this.selectedUserId !== null && this.selectedUserId !== '') {
      this.bootstrap();
    }
  },

  computed: {
    creditUsedIsZero() {
      return this.originalCreditUsed === 0.0;
    },
  },

  methods: {
    async bootstrap() {
      // To Do Getting the UserCredits by UserId
      try {
        await this.$store.dispatch(FETCH_USER_CREDIT_BY_ID, { userId: this.selectedUserId });
        this.userCredit = this.$store.getters.accountingSelectedUserCredit;
        this.originalCreditTotalAmount = this.userCredit.creditTotalAmount;
        this.originalCreditUsed = this.userCredit.creditUsed;
      } catch (err) {
        console.error('get_usercredit_byid err', err);
        if (err.message === 'Network Error') {
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'UnAuthorized' });
        }
      }
    },
    async onProcessClick() {
      try {
        const credit = this.userCredit;
        await this.$store.dispatch(PROCESS_USER_CREDIT, { data: credit }).then(() => {
          this.$parent.notificationToasts.push({
            title: 'Success!',
            content: 'User Credit updated successfully!',
            cssClass: 'e-toast-success',
            timeOut: 5000,
          });
        });
      } catch (error) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: error.message,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }

      this.$router.push('/accounting/manage-accounting');
    },
    onCancelClick() {
      this.$router.push('/accounting/manage-accounting');
    },
    async onDeleteCreditClicked() {
      DialogObj = DialogUtility.confirm({
        title: 'Delete User Credit',
        content: 'Are you sure you want to delete the credit limit?',
        okButton: { text: 'OK', click: this.deleteCreditLimit },
        cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: 'Zoom' },
      });
    },
    hideDeleteDialog() {
      DialogObj.hide();
    },
    async deleteCreditLimit() {
      this.hideDeleteDialog();
      if (this.userCredit.creditUsed !== 0) {
        this.$parent.showToastNotification(
          'Error !',
          'Error: To delete User Credit, credit used has to be Zero',
          'e-toast-danger',
        );
        return;
      }

      const userCreditId = this.userCredit.creditId;
      await deleteUserCredit(userCreditId)
        .then(() => {
          this.$parent.notificationToasts.push({
            title: 'Success!',
            content: 'User credit limit was deleted',
            cssClass: 'e-toast-succcess',
            timeOut: 5000,
          });
        })
        .catch(() => {
          this.$parent.notificationToasts.push({
            title: 'Error!',
            content: 'Error while deleting User Credit',
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        });

      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
      this.$router.push('/accounting/manage-accounting');
    },
  },

};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 .e-card-content {
  margin: 0% !important;
}

.container2 {
  display: flex;
  flex-flow: row;
  min-height: 50px;
  text-align: left;
  border-style: groove;
  margin: 10px;
  width:95%;
}

.leftcol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.middlecol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.colrow {
  margin: 8px;
  flex: 1;
}

.data-flex-row{
  display: flex;
  flex-direction: row;
}

.data-flex-cell{
  flex: 1;
}
</style>
